export default "__VITE_ASSET__85c6f274__"